import { replace } from "connected-react-router";
import { connect } from "react-redux";
import { ROOT } from "../../constants/routes";
import ErrorPage from "../../components/ErrorPages/ErrorPage";

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
    goToHome: () => dispatch(replace(ROOT))
});

export default connect(mapStateToProps, mapDispatchToProps)(ErrorPage);
